import { createReducer, on } from '@ngrx/store';
import { HttpError } from '@rd/types';
import { EverydaySpendCheckoutFormData } from '../../types/checkout-form-data.type';
import { EverydaySpendActions } from '../actions/everyday-spend.actions';

export interface EverydaySpendState {
  formData: Record<string, EverydaySpendCheckoutFormData | null>;
  pointsTransfer: {
    loading: boolean;
    error: HttpError | null;
  };
}

const initialState: EverydaySpendState = {
  formData: {},
  pointsTransfer: {
    loading: false,
    error: null,
  },
};

export const everydaySpendReducer = createReducer(
  initialState,
  on(
    EverydaySpendActions.submitCheckoutFormData,
    (state, { loyaltyProgramId, formData }) => ({
      ...state,
      formData: { ...state.formData, [loyaltyProgramId]: formData },
    }),
  ),
  on(EverydaySpendActions.submitPointsTransfer, (state) => ({
    ...state,
    pointsTransfer: {
      ...state.pointsTransfer,
      loading: true,
    },
  })),
  on(EverydaySpendActions.submitPointsTransferSuccess, (state) => ({
    ...state,
    pointsTransfer: {
      ...state.pointsTransfer,
      loading: false,
      error: null,
    },
  })),
  on(EverydaySpendActions.submitPointsTransferFailure, (state, { error }) => ({
    ...state,
    pointsTransfer: {
      ...state.pointsTransfer,
      loading: false,
      error,
    },
  })),
  on(EverydaySpendActions.clearPointsTransferError, (state) => ({
    ...state,
    pointsTransfer: {
      ...state.pointsTransfer,
      error: null,
    },
  })),
  on(
    EverydaySpendActions.clearCheckoutFormData,
    (state, { loyaltyProgramId }) => ({
      ...state,
      formData: { ...state.formData, [loyaltyProgramId]: null },
    }),
  ),
  on(EverydaySpendActions.hydrateRedemption, (state, { hydrationData }) => {
    const { sourceAmount, targetAmount, membershipId, loyaltyProgramId } =
      hydrationData.data;

    return {
      ...state,
      formData: {
        ...state.formData,
        [loyaltyProgramId]: { membershipId, targetAmount, sourceAmount },
      },
    };
  }),
);
